// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../generated-types'

import gql from 'graphql-tag'
import { UserInfoFragmentDoc } from '../../ProductFruits/ProductFruits.generated'
import { EventHeaderFragmentDoc } from './EventHeader/EventHeader.generated'
import * as Urql from 'urql'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
export type GuestFragment = {
  __typename?: 'Guest'
  firstName: string
  lastName?: string | null
  email?: string | null
  phoneNumber?: string | null
  mobileNumber?: string | null
}

export type SpaceStyleFragment = {
  __typename?: 'SpaceStyle'
  id: string
  label: string
}

export type FeatureFragment = {
  __typename?: 'Feature'
  id: number
  name: string
}

export type EventInformationFragment = {
  __typename?: 'Enquiry'
  id: number
  notes?: string | null
  uuid: string
  status: Types.EnquiryStatus
  currency: string
  eventDateFrom: any
  eventDateTo: any
  eventMacroType?: string | null
  location: string
  latitude: number
  longitude: number
  radius: number
  budget: number
  layout: string
  guestsCount: number
  timings?: string | null
  flexibleDates: boolean
  cateringNeeds?: string | null
  createDate: any
  guestId: number
  country: string
  title: string
  audience: Types.Audience
  flexibility: {
    __typename?: 'Flexibility'
    flexibleDates: boolean
    flexibleTimes: boolean
    notes?: string | null
  }
  guest?: {
    __typename?: 'Guest'
    firstName: string
    lastName?: string | null
    email?: string | null
    phoneNumber?: string | null
    mobileNumber?: string | null
  } | null
  optionalSpaceFacilities: Array<{
    __typename?: 'Feature'
    id: number
    name: string
  }>
  requiredSpaceFacilities: Array<{
    __typename?: 'Feature'
    id: number
    name: string
  }>
  spaceStyles?: Array<{
    __typename?: 'SpaceStyle'
    id: string
    label: string
  }> | null
  collection: { __typename?: 'Collection'; label: string }
}

export type EventInformationQueryVariables = Types.Exact<{
  uuid: Types.Scalars['String']
}>

export type EventInformationQuery = {
  __typename?: 'Query'
  enquiryByUUID?: {
    __typename?: 'Enquiry'
    id: number
    notes?: string | null
    uuid: string
    status: Types.EnquiryStatus
    currency: string
    eventDateFrom: any
    eventDateTo: any
    eventMacroType?: string | null
    location: string
    latitude: number
    longitude: number
    radius: number
    budget: number
    layout: string
    guestsCount: number
    timings?: string | null
    flexibleDates: boolean
    cateringNeeds?: string | null
    createDate: any
    guestId: number
    country: string
    title: string
    audience: Types.Audience
    flexibility: {
      __typename?: 'Flexibility'
      flexibleDates: boolean
      flexibleTimes: boolean
      notes?: string | null
    }
    guest?: {
      __typename?: 'Guest'
      firstName: string
      lastName?: string | null
      email?: string | null
      phoneNumber?: string | null
      mobileNumber?: string | null
    } | null
    optionalSpaceFacilities: Array<{
      __typename?: 'Feature'
      id: number
      name: string
    }>
    requiredSpaceFacilities: Array<{
      __typename?: 'Feature'
      id: number
      name: string
    }>
    spaceStyles?: Array<{
      __typename?: 'SpaceStyle'
      id: string
      label: string
    }> | null
    collection: { __typename?: 'Collection'; label: string }
  } | null
}

export const GuestFragmentDoc = gql`
  fragment Guest on Guest {
    firstName
    lastName
    email
    phoneNumber
    mobileNumber
  }
`
export const FeatureFragmentDoc = gql`
  fragment Feature on Feature {
    id
    name
  }
`
export const SpaceStyleFragmentDoc = gql`
  fragment SpaceStyle on SpaceStyle {
    id
    label
  }
`
export const EventInformationFragmentDoc = gql`
  fragment EventInformation on Enquiry {
    id
    notes
    uuid
    status
    currency
    eventDateFrom
    eventDateTo
    eventMacroType
    location
    latitude
    longitude
    radius
    budget
    layout
    guestsCount
    timings
    flexibleDates
    flexibility {
      flexibleDates
      flexibleTimes
      notes
    }
    guest {
      ...Guest
    }
    optionalSpaceFacilities {
      ...Feature
    }
    requiredSpaceFacilities {
      ...Feature
    }
    cateringNeeds
    spaceStyles {
      ...SpaceStyle
    }
    createDate
    ...UserInfo
    ...EventHeader
  }
  ${GuestFragmentDoc}
  ${FeatureFragmentDoc}
  ${SpaceStyleFragmentDoc}
  ${UserInfoFragmentDoc}
  ${EventHeaderFragmentDoc}
`
export const EventInformationDocument = gql`
  query EventInformation($uuid: String!) {
    enquiryByUUID(uuid: $uuid) {
      ...EventInformation
    }
  }
  ${EventInformationFragmentDoc}
`

export function useEventInformationQuery(
  options: Omit<Urql.UseQueryArgs<EventInformationQueryVariables>, 'query'>
) {
  return Urql.useQuery<EventInformationQuery>({
    query: EventInformationDocument,
    ...options,
  })
}
